/**
 * AddPoints.js
 *
 * Component to manually award points to a user.
 * ------------------------------------------------------------
 * - Admin enters User ID / Name and points to add.
 * - On submit, updates Firestore (adds to existing points if present).
 */

import React, { useState } from "react";
import Button from "../../../components/ui/Button";
import { addPointsToDatabase } from "../helpers/resultHelpers";
import toast from "react-hot-toast";

const AddPoints = ({ roomID }) => {
    const [points, setPoints] = useState("");
    const [loading, setLoading] = useState("");

    /**
     * Handles form submission and updates Firestore.
     */
    const handleAddPoints = async (e) => {
        e.preventDefault();
        if (!points) {
            return;
        }
        setLoading(true);
        const res = await addPointsToDatabase(points, roomID);
        if (res)
            toast.success('Added Points Successfully!');
        else 
            toast.error('Error adding points');
        setLoading(false);
    };

    // ----------------------------------------
    // UI
    // ----------------------------------------
    return (
        <div className="w-full bg-black text-white flex flex-col items-center justify-center px-6 py-10">
            <h1 className="text-3xl sm:text-4xl font-bold mb-6">Add Points</h1>

            <form
                onSubmit={handleAddPoints}
                className="flex items-center gap-3 w-full max-w-sm text-black"
            >
                {/* Points Input */}
                <input
                    type="number"
                    placeholder="Enter Points"
                    value={points}
                    onChange={(e) => setPoints(e.target.value)}
                    className="flex-1 p-2 rounded-md outline-none border border-zinc-300 focus:ring-2 focus:ring-blue-500"
                />

                {/* Add (+) Button */}
                <Button
                    type="submit"
                    variant="secondary"
                    disabled={loading}
                    className="px-4 py-2 font-bold text-lg"
                >
                    {loading ? "..." : "+"}
                </Button>
            </form>
        </div>
    );
};

export default AddPoints;